<main class="page">
  <header class="page-header">
    <div class="page-header-top">
      <h1>Vehicle Explorer</h1>
      @if (showSwaggerLink) {
        <a class="swagger-link" href="/swagger" target="_blank" rel="noopener">API Docs (Swagger)</a>
      }
    </div>
    <p>Look up available vehicle types and models by make and year, using NHTSA's public vehicle data.</p>
  </header>

  <app-vehicle-explorer />
</main>
